export const formatMixin = {
  methods: {
    /** 美分转美元 */
    handleUSDollar(amount) {
      if (amount === 0) {
        return amount
      }
      return (amount / 100).toFixed(2)
    },
    handelFeeTax(num1, num2) {
      return Math.round((num1 / 100) * (num2 / 100))
    },
    returnFloat(num) {
      if (num === undefined || num === null || num === '') {
        return '0.00'
      }
      num = num.toString()
      if (num.indexOf('.') !== -1) {
        let [integerPart, decimalPart] = num.split('.')
        if (decimalPart.length > 2) {
          decimalPart = decimalPart.substring(0, 2)
        }
        if (decimalPart.length === 1) {
          decimalPart += '0'
        }
        num = `${integerPart}.${decimalPart}`
      }
      //
      else {
        num += '.00'
      }
      return num
    },
    handleNumberTransformK(num) {
      if (num === null || num === undefined) {
        return ''
      }
      if (typeof num !== 'number' && typeof num !== 'string') {
        return 'NaN'
      }
      if (num == 0) {
        return '0'
      }

      num = num / 100

      if (this.locaCode === 'ID') {
        const myNum = num * 1
        const kValue = Math.floor((myNum / 1000) * 100) / 100
        if (Number.isInteger(kValue)) {
          return `${kValue}K`
        }
        return `${kValue.toFixed(2)}K`
      }
      return this.returnFloat(num)
    },
  },
}
